import { UPDATE_CUSINES, UPDATE_RESTAURANT_INFO, UPDATE_RESTAURANT_LIST, UPDATE_RESTAURANT_SEARCH_KEY, RESET_STATE } from "../actionTypes/restaurantTypes";

export function updateRestaurantSearchKey(payload) {
  return { type: UPDATE_RESTAURANT_SEARCH_KEY, payload };
}

export function updateRestaurantList(payload) {
  return { type: UPDATE_RESTAURANT_LIST, payload };
}

export function updateCusines(payload) {
  return { type: UPDATE_CUSINES, payload };
}

export function updateRestaurantInfo(payload) {
  return { type: UPDATE_RESTAURANT_INFO, payload };
}


